export const sentryOauthPopupEventType = 'agentteams:sentry-oauth-complete';

export const openSentryOauthPopup = (url: string): Window | null => {
  if (typeof window === 'undefined') return null;
  const width = 640;
  const height = 760;
  const left = Math.max(0, Math.round((window.screen.width - width) / 2));
  const top = Math.max(0, Math.round((window.screen.height - height) / 2));
  const popup = window.open(
    url,
    'agentteams-sentry-oauth',
    [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      'popup=yes',
      'resizable=yes',
      'scrollbars=yes',
    ].join(','),
  );
  popup?.focus();
  return popup;
};

export const buildSentryOauthPopupRedirectPath = (nextPath: string): string => {
  const normalizedNextPath = nextPath.startsWith('/') ? nextPath : '/';
  return `/auth/sentry-popup-complete?next=${encodeURIComponent(normalizedNextPath)}`;
};
